import React from 'react';
import { Helmet } from 'react-helmet-async';
import ContactForm from '../components/ContactForm';

export default function Contact() {
  return (
    <>
      <Helmet>
        <title>Kontakt os | Tømrerfirmaet RNS i Glatved på Djursland</title>
        <meta name="description" content="Kontakt Tømrerfirmaet RNS på Djursland. Ring til os på +45 22 43 91 47, send en mail til trns@mail.dk, eller udfyld vores kontaktformular for et uforpligtende tilbud på tømrer- og malerarbejde." />
        <meta property="og:title" content="Kontakt os | Tømrerfirmaet RNS i Glatved på Djursland" />
        <meta property="og:description" content="Kontakt Tømrerfirmaet RNS på Djursland. Ring til os på +45 22 43 91 47, send en mail til trns@mail.dk, eller udfyld vores kontaktformular for et uforpligtende tilbud på tømrer- og malerarbejde." />
        <meta property="og:image" content="https://assets.auxodev.dk/assets/d1f69564-4a06-4909-b6f1-fa1f6ad6911e/img-0027-scaled.jpg" />
        <link rel="canonical" href="https://rns.dk/kontakt" />
        <html lang="da-DK" />
      </Helmet>

      {/* Contact Grid Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* Page Title */}
          <div className="lg:col-span-12 text-center space-y-2 max-w-2xl mx-auto mb-6">
            <h1 className="font-display font-extrabold text-4xl text-slate-900">
              Kontakt Os
            </h1>
            <p className="text-slate-600">
              Har du et projekt, du ønsker et uforpligtende tilbud på? Eller har du blot spørgsmål til vores arbejde? Vi står klar til at hjælpe dig.
            </p>
          </div>

          {/* Info Column */}
          <div className="lg:col-span-5 space-y-8">
            <div className="space-y-4">
              <h2 className="font-display font-extrabold text-3xl text-slate-900">
                Lad os tage en snak om dit projekt
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Vi dækker hele Djursland, herunder Grenaa, Ebeltoft, Balle, Tirstrup og omegn. Vi rådgiver dig gerne om materialevalg, energikrav og de bedste løsninger til netop din bolig eller dit sommerhus.
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-start gap-4 bg-white p-5 rounded-none shadow-md border border-slate-100">
                <div className="w-12 h-12 rounded-none bg-black flex items-center justify-center text-white text-xl shrink-0">
                  <i className="fa-solid fa-phone text-white" />
                </div>
                <div>
                  <h4 className="font-semibold text-slate-800 text-sm">Ring til os</h4>
                  <p className="text-xs text-slate-500 mb-1">Vi svarer så hurtigt vi kan</p>
                  <a href="tel:22439147" className="text-slate-900 hover:text-slate-700 hover:underline font-bold text-lg whitespace-nowrap">
                    +45 22 43 91 47
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-white p-5 rounded-none shadow-md border border-slate-100">
                <div className="w-12 h-12 rounded-none bg-black flex items-center justify-center text-white text-xl shrink-0">
                  <i className="fa-solid fa-envelope text-white" />
                </div>
                <div>
                  <h4 className="font-semibold text-slate-800 text-sm">Send os en e-mail</h4>
                  <p className="text-xs text-slate-500 mb-1">Vi besvarer e-mails inden for 24 timer</p>
                  <a href="mailto:trns@mail.dk" className="text-slate-900 hover:text-slate-700 hover:underline font-bold text-lg whitespace-nowrap">
                    trns@mail.dk
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-white p-5 rounded-none shadow-md border border-slate-100">
                <div className="w-12 h-12 rounded-none bg-black flex items-center justify-center text-white text-xl shrink-0">
                  <i className="fa-solid fa-location-dot text-white" />
                </div>
                <div>
                  <h4 className="font-semibold text-slate-800 text-sm">Vores adresse</h4>
                  <p className="text-xs text-slate-500 mb-1">Tømrerfirmaet RNS</p>
                  <p className="text-slate-700 font-medium text-sm">
                    Glatvedvej 28, 8444 Balle
                  </p>
                </div>
              </div>
            </div>

            {/* CVR & Legal Info */}
            <div className="border-t border-slate-100 pt-6 space-y-2 text-xs text-slate-500">
              <p><strong>Tømrerfirmaet RNS</strong></p>
              <p>CVR-nummer: 36083131</p>
              <p>Base i Glatved på Djursland</p>
            </div>
          </div>

          {/* Form Column */}
          <div className="lg:col-span-7">
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}
